import withAdvisors from '@rategravity/frontend/components/with-advisors';
import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import MediaQuery from 'react-responsive';

const style = {
  container: {
    padding: '1.5em 2em',
    position: 'relative'
  },
  availability: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.5em'
  },
  available: {
    height: 8,
    width: 8,
    backgroundColor: 'green',
    borderRadius: 8,
    marginRight: '.5em'
  },
  name: {
    lineHeight: 1.1
  },
  bigmike: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: '10em'
  },
  smallMike: {
    height: '4em',
    width: '4em',
    borderRadius: '4em',
    margin: '.5em .5em .5em 0'
  },
  copy: {
    textAlign: 'left'
  },
  advisor: {
    display: 'flex',
    alignItems: 'center'
  }
};

export default withAdvisors(({ advisor, bgColor, advisors }) => {
  const advisorData = advisors[advisor || 'mike'];
  const backgroundColor =
    bgColor === 'blue' ? colors['tertiary-light'] : colors['quarternary-light'];
  if (!!advisorData) {
    return (
      <div style={{ ...style.container, ...{ backgroundColor } }}>
        <div style={style.availability} className="preapproval__large__left">
          <div style={style.available} />
          <h6> Available This Week </h6>
        </div>
        <div style={style.advisor} className="preapproval__large__left">
          <MediaQuery maxWidth={799}>
            <img src={advisorData.photo} role="presentation" style={style.smallMike} />
          </MediaQuery>
          <div>
            <h4 style={style.name}>{advisorData.name.full}</h4>
            <h6>
              {advisor ? 'Your Advisor' : 'Mortgage Advisor'}, MLO #{advisorData.mlo}
            </h6>
          </div>
        </div>
        <br />
        <p className="agent__copy" style={style.copy}>
          {advisorData.bio}
        </p>
        <MediaQuery minWidth={800}>
          <img
            src={advisorData.big_photo || advisorData.photo}
            role="presentation"
            style={style.bigmike}
          />
        </MediaQuery>
      </div>
    );
  }
  return null;
});



// WEBPACK FOOTER //
// ./src/components/complete/agent.js